import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { ICssProperty } from "common/theme/CssPropertyProvider";


@Form({title: "Table View Config"})
export default class TableViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Show Cell Borders"})
	public cellBorders?: boolean;

	@Input({type: InputType.NUMBER, title: "Show Cell Borders"})
	public cellPadding: number = 15;

	@Input({type: InputType.NUMBER, title: "Skeleton primary row height"})
	public skeletonCellHeightPrimary: number = 20;

	@Input({type: InputType.NUMBER, title: "Skeleton secondary row height"})
	public skeletonCellHeightSecondary: number = 20;

	@Input({type: InputType.NUMBER, title: "Default sleleton items (after the 1st render this is saved"})
	public defaultSkeletonCount?: number = 6;
}



// WEBPACK FOOTER //
// ./src/common/views/table/TableViewConfig.ts